export const getThemeColor = (color: any) => {
    switch (color) {
        case "red": return "#a94747";
        case "green": return "#0c995e";
        case "blue": return "#228dc7";
        case "orange": return "#de9e27";
        case "sea": return "#3a908c";
        case "maranics": return "#2e4e5e";
        case "grass": return "#75c471";
        case "pinky": return "#f98888";
        case "lemon": return "#ffe3a3";
        case "lightgray": return "#d7d7d7";
        case "violet": return "rgb(109, 32, 113)";
        default: return "gray";
    }
}

export const getThemeFadedColor = (color: any) => {
    switch (color) {
        case "red": return "#a9474739";
        case "green": return "#0c995e39";
        case "blue": return "#228dc739";
        case "sea": return "#3a908c";
        case "orange": return "#fceac8";
        case "violet": return "rgb(230, 197, 238)";
        default: return "lightgray";
    }
}


// color: rgb(46, 78, 94);
// background-color: #5ca4513d;